<!-- eslint-disable -->
<template lang="pug">
  div
    div.build-info
      p info backend
      pre {{backend_data}}

    div.build-info
      p info frontend
      pre {{frontend_data}}

</template>

<script>
    /* eslint-disable no-alert, no-console */
    import { mapState } from 'vuex';
    import { apiCallers } from '@/api/apiRequest';

    export default {
      name: 'info',
      data: function(){
        return {
          backend_data: '{}',
          frontend_data: {
            /* global __BUILD_DATE */
            BuildDate: __BUILD_DATE,
            /* global __GIT_VERSION */
            GitVersion: __GIT_VERSION,
            /* global __GIT_BRANCH */
            GitRemote: __GIT_BRANCH,
          },
        };
      },
      computed: {
        ...mapState(['appConfigs']),
        apiRequest() {
          return apiCallers[this.config.app];
        },

        config() {
          return this.appConfigs[this.$options.configIndex] || {};
        },
      },
      mounted: function (){
        this.loadData();
      },
      methods: {
        loadData() {
          if (!this.apiRequest) {
            return;
          }
          this.apiRequest
            .get(this.config.paths.infodata)
            .then(response => {
              if (response && response.data) {
                this.backend_data = response.data;
              }
            });
        }
      }
    };
</script>

<style scoped>
.build-info {
  padding: 20px;
}
.build-info pre {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/apps/info/spv.vue